import Image from 'next/image'
import { ReactNode } from 'react'

import { cn } from '@/_lib/utils'

const AJobsHeroCard = ({
	title,
	icon,
	value, // TODO: premyslieť, či to nevymazať, pretože už sa to nikde nepoužíva
	className
}: {
	title: string | ReactNode
	icon?: string
	value?: string
	className?: string
}) => {
	return (
		<div
			className={cn(
				'flex flex-col items-between justify-between p-5 rounded-3xl gap-4 lg:gap-4 h-full',
				className
			)}
		>
			<p className={cn('text-base font-light')}>{title}</p>

			{(icon || value) && (
				<div
					className={cn(
						'flex items-center',
						icon && value ? 'justify-between' : 'justify-end'
					)}
				>
					{icon && (
						<Image
							src={icon}
							alt={typeof title === 'string' ? title : ''}
							width={56}
							height={56}
							className='size-12 lg:size-16'
							unoptimized={true}
						/>
					)}

					{value && (
						<p
							className={cn(
								'text-5xl lg:text-[64px] font-normal text-end leading-none'
							)}
						>
							{value}
						</p>
					)}
				</div>
			)}
		</div>
	)
}

export default AJobsHeroCard
